module.exports = __webpack_public_path__ + "img/shezhi.b8cd6dbc.png";